 import { SAVINGS_POT_CALCULATOR_FORM_SET_VALUE} from "../../../actions/savingsPotCalculator/savingsPotCalculatorForm" 
 import {savingsPotCalculatorFieldTracking} from "./savingsPotCalculatorForm"
 
 export const savingsPotCalculatorTracking = (store, next, action) => {
     if (action.type.startsWith(SAVINGS_POT_CALCULATOR_FORM_SET_VALUE))
     return savingsPotCalculatorFieldTracking(store, next, action);
 
     return null;
 };